export const state = () => ({
  productRecommendationMap: new Map(),
  optimizerLanguage: 'alt1',
  indexedProductPrices: {},
  useOneService: false
});
